// extracted by mini-css-extract-plugin
export default {"IconButton":"IconButton_IconButton__PgBBL"};